import React, { useState } from "react";
import { Form, Card } from "antd";
import logo from "../../assets/img/img_common_form_logo_n@2x.png";
import "antd/dist/antd.css";
import "./ForgotPassword.scss";
import MainButton from "../../components/MainButton/MainButton.jsx";
import TextInput from "../../components/TextInput/TextInput.jsx";
import {
  checkMobile,
  forgetPassword,
} from "../../api/apiStore/ForgetPassword/ForgetPassword";
import ConfirmModal from "../../components/ConfirmModal";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading/Loading.jsx";

export default function ForgotPassword() {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const [confirmModalMsg, setConfirmModalMsg] = useState("");
  const [confirmModal, setConfirmModal] = useState({
    title: "提示",
    visible: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  let forgetHandler = false;
  const forgotPassword = async (mobile) => {
    setIsLoading(true);
    const resp = await forgetPassword(mobile);
    setIsLoading(false);
    if (resp.result.Code === "0") {
      setConfirmModal(() => {
        forgetHandler = true;
        return { title: "提示", visible: true };
      });
      setConfirmModalMsg("寄送成功，請至手機簡訊查看。");
      navigate("/login");
    } else {
      setConfirmModal(() => {
        return { title: "提示", visible: true };
      });
      setConfirmModalMsg(resp.result.Message);
    }
  };

  function onFinish() {
    form
      .validateFields()
      .then(async (values) => {
        setIsLoading(true);
        const resp = await forgotPassword({ mobile: values.mobile });
        setIsLoading(false);
        if (resp) {
          return;
        }
        return;
      })
      .catch((error) => {
        const { errorFields } = error;
        const filterErrorMsg = errorFields.map((item) => {
          const { errors } = item;
          item.errors = [...new Set(errors)];
          return item;
        });
      });
  }

  const handleOk = () => {
    setConfirmModal(() => {
      return { title: "提示", visible: false };
    });
    if (forgetHandler) {
      navigate("/login");
    }
  };

  return (
    <div>
      <Loading isLoadingVisible={isLoading}></Loading>
      <Card type="inner" className="forgotPasswordPage-basic">
        <img style={{ width: "100%", height: "100%" }} src={logo} />
        <Form
          form={form}
          name="basic"
          autoComplete="off"
          validateTrigger="onSubmit"
        >
          <Form.Item
            name="mobile"
            rules={[
              {
                required: true,
                message: "手機號碼為必填",
              },
              {
                len: 10,
                message: "手機號碼格式錯誤",
              },
            ]}
          >
            <TextInput title="手機號碼" placeholder="共10碼" />
          </Form.Item>
          <p className="sub-text">
            請輸入您手機註冊時的手機號碼，系統會自動傳送密碼至您的手機。五分鐘內未收到簡訊請出新發送，24小時內限發送三次
          </p>
          <MainButton buttonType="main" onClick={onFinish}>
            送出
          </MainButton>
        </Form>
      </Card>
      {confirmModal.visible ? (
        <ConfirmModal
          title={confirmModal.title}
          setModalvisible={confirmModal.visible}
          setHandleOk={handleOk}
          msg={confirmModalMsg}
        />
      ) : null}
    </div>
  );
}
